// components/OrderViewer/components/GeneralView/GeneralView.tsx

import React from 'react';
// Removed unused imports - components now use modular sub-components
import { Selection, Pedido } from '../../types';
import SelectionRow from './components/SelectionRow/SelectionRow';
import './GeneralView.scss';

interface GeneralViewProps {
  selections: (Selection & { pedido: Pedido })[];
  allowEdit: boolean;
  handleIncreaseQuantity: (pedido_id: number, selection_id: string) => void;
  handleDecreaseQuantity: (pedido_id: number, selection_id: string) => void;
  handleChangeOwner: (pedido_id: number, selection_id: string, new_client_index: number) => void;
  handleDeleteSelection: (pedido_id: number, selection_id: string) => void;
  handleSplitSelection?: (pedido_id: number, selection_id: string) => void;
  isSelectionMode?: boolean;
  selectedItems?: Set<string>;
  onToggleSelection?: (pedido_id: number, selection_id: string) => void;
}

const GeneralView: React.FC<GeneralViewProps> = ({
  selections,
  allowEdit,
  handleIncreaseQuantity,
  handleDecreaseQuantity,
  handleChangeOwner,
  handleDeleteSelection,
  handleSplitSelection,
  isSelectionMode = false,
  selectedItems = new Set(),
  onToggleSelection,
}) => {
  const [numPeople] = React.useState(50);
  const [activeDropdownId, setActiveDropdownId] = React.useState<string | null>(null);

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (activeDropdownId) {
        const target = event.target as Element;
        const isInsideDropdown = target.closest('.custom-dropdown-container') || target.closest('.portal-dropdown-menu');
        if (!isInsideDropdown) {
          setActiveDropdownId(null);
        }
      }
    };

    if (activeDropdownId) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [activeDropdownId]);

  const handleToggleDropdown = (dropdownId: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    
    if (activeDropdownId === dropdownId) {
      setActiveDropdownId(null);
    } else {
      setActiveDropdownId(dropdownId);
    }
  };

  const handleSelectClient = (pedidoId: number, selectionId: string, clientIndex: number) => {
    handleChangeOwner(pedidoId, selectionId, clientIndex);
    setActiveDropdownId(null);
  };

  return (
    <div className={`general-view ${activeDropdownId ? 'has-active-dropdown' : ''}`}>
      <table className="selections-table">
        <tbody>
          {selections.map((sel) => (
            <SelectionRow
              key={`${sel.pedido.pedido_id}-${sel.selection_id}`}
              selection={sel}
              allowEdit={allowEdit}
              activeDropdownId={activeDropdownId}
              onIncreaseQuantity={handleIncreaseQuantity}
              onDecreaseQuantity={handleDecreaseQuantity}
              onDeleteSelection={handleDeleteSelection}
              onSplitSelection={handleSplitSelection}
              onToggleDropdown={handleToggleDropdown}
              onSelectClient={handleSelectClient}
              numPeople={numPeople}
              isSelectionMode={isSelectionMode}
              isSelected={selectedItems.has(`${sel.pedido.pedido_id}:${sel.selection_id}`)}
              onToggleSelection={onToggleSelection}
            />
          ))}
        </tbody>
      </table>


    </div>
  );
};

export default GeneralView;
